import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";

import ModalTemplate from "../../../common/ModalTemplate";
import { fetchPaymentTerms, updateFtmPaymentTerms } from '../../service';
import { theme } from "../../../theme";
import BtnSpinner from "../../../common/BtnSpinner";
import DivSpinner from "../../../common/DivSpinner";
import { Context } from "../../Provider";

const PaymentTerms = ({ show, handleClose }) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
    } = useForm();

    const { state, updateCurrentStep } = useContext(Context);
    const { ftm } = state;

    const [details, setDetails] = useState({
        loading: true,
        terms: []
    });

    const [buttonLoading, setButtonLoading] = useState(false);

    useEffect(() => {
        const getPaymentTerms = async () => {
            try {
                const response = await fetchPaymentTerms();
                if (response.status === "Success") {
                    setDetails({
                        loading: false,
                        terms: response.terms
                    });

                    // Set default selected term
                    const defaultTerm = response.terms.find(term => term.ftm_payment_term_is_default === 1);
                    if (defaultTerm) {
                        setValue("payment_term", defaultTerm.ftm_payment_term_id.toString());
                    }
                } else {
                    setDetails({
                        loading: false,
                        terms: []
                    });
                }
            } catch (err) {
                setDetails({
                    loading: false,
                    terms: []
                });
            }
        };

        getPaymentTerms();
    }, [setValue]);

    const Locading = () => (
        <div style={{ height: `${window.innerHeight - 387}px` }}>
            <DivSpinner />
        </div>
    );

    const onSubmit = async (data) => {
        const selectedTermId = data.payment_term;
        // you can now send `selectedTermId` to your backend or use it as needed

        try {
            setButtonLoading(true);
            const response = await updateFtmPaymentTerms({ ftm_id: ftm.ftm_id, term_id: selectedTermId });
            if (response.status === "Success") {
                updateCurrentStep(5);
                toast.success(response.message);
                handleClose();
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.error("Registration failed:", error);
            toast.error("Registration failed.");
        } finally {
            setButtonLoading(false);
        }
    };

    const Body = () => (
        <form onSubmit={handleSubmit(onSubmit)} className="m-2">
            <div className="row gx-2 gx-sm-3 mb-3">
                <h5 className="mb-1 text-gradient text-dark mb-4">Payment Terms</h5>
                {details.terms.map((term, index) => (
                    <div className="form-check mb-3" key={term.ftm_payment_term_id}>
                        <input
                            className="form-check-input success-radio"
                            type="radio"
                            id={`term-${term.ftm_payment_term_id}`}
                            value={term.ftm_payment_term_id}
                            {...register("payment_term", { required: true })}
                        />
                        <label className="custom-control-label" htmlFor={`term-${term.ftm_payment_term_id}`}>
                            {term.ftm_payment_term_name}
                        </label>
                        {term.ftm_payment_term_is_default === 0 && (
                            <p className={`text-danger text-xs`}>
                                We will charge additional {term.ftm_payment_term_additional_charge_percentage}%
                            </p>
                        )}
                        <p className={`text-xs`}>
                            {term.ftm_payment_term_description}
                        </p>
                    </div>
                ))}
                {errors.payment_term && <p className="text-danger text-xs">Please select a payment term.</p>}
            </div>
            <div>
                <label className={`text-xs fw-bold`}>Note: You can change this later</label>
            </div>
            <div className="text-center">
                <button
                    type="submit"
                    className={`btn btn-sm bg-gradient-${theme.main} w-100 mb-0`}
                    disabled={buttonLoading}
                >
                    {buttonLoading ? <BtnSpinner /> : "PROCEED"}
                </button>
            </div>
        </form>
    );

    return (
        <ModalTemplate
            show={show}
            handleClose={handleClose}
            size={null}
            centered
            title={null}
            body={details.loading ? <Locading /> : <Body />}
            footer={null}
            backdrop="static"
            keyboard={false}
        />
    );
};

export default PaymentTerms;